import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

type IndikatorPerencanaanPanelProps = {
  variant?: 'active' | 'static'
  label?: string
  orderNumber?: number | string
  title?: string
  children?: React.ReactNode
  upperContent?: React.ReactNode
}

export function IndikatorPerencanaanPanel({
  variant = 'static',
  label,
  orderNumber,
  title,
  children,
  upperContent,
}: IndikatorPerencanaanPanelProps) {
  return (
    <div
      className={clsx(
        'rounded  border border-subdued p-6',
        variant === 'active' && 'bg-surface-selected-default',
        variant === 'static' && 'bg-white'
      )}
    >
      {upperContent && <div className="mb-6">{upperContent}</div>}

      <div className="flex gap-6">
        {orderNumber && (
          <Text variant="heading-sm" className="!text-blue-600">
            {orderNumber}.
          </Text>
        )}
        <div className="space-y-2 w-full">
          {label && (
            <Text variant="body-sm" className="!text-blue-500">
              {label}
            </Text>
          )}
          {title && (
            <Text
              variant="body"
              className="text-justify inline-block"
              as="label"
            >
              {title}
            </Text>
          )}
          {children}
        </div>
      </div>
    </div>
  )
}
